import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-notif-intervention-terminee',
  templateUrl: './notif-intervention-terminee.component.html',
  styleUrls: ['./notif-intervention-terminee.component.scss'],
})
export class NotifInterventionTermineeComponent implements OnInit {
  nom: string;
  constructor(private navParams: NavParams, private modalController: ModalController) {
    this.nom = this.navParams.get('nom');
  }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}
